module.exports = __webpack_public_path__ + "img/bluearhive.f833c198.png";